/**
 * Skinoria hero — crossfading background slides and the video fade-in.
 *
 * Kept deliberately small: no observers beyond one for visibility, no rAF loop.
 * Rotation pauses while the tab is hidden and while the hero is scrolled out of
 * view, so a phone left on the homepage is not decoding images for nothing.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideo(hero) {
    var video = hero.querySelector('.sk-hero2__video');
    if (!video) return;
    var ready = function () { video.classList.add('is-ready'); };
    if (video.readyState >= 2) ready();
    else video.addEventListener('canplay', ready, { once: true });
    // Some mobile browsers refuse the autoplay attribute but allow play() on a
    // muted, inline video. Failing that, the poster underneath is the fallback.
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
  }

  function initSlides(hero) {
    var slides = hero.querySelectorAll('.sk-hero2__slide');
    if (slides.length < 2) return;

    var bars = hero.querySelectorAll('.sk-hero2__bar');
    var delay = parseInt(hero.getAttribute('data-sk-hero-rotate'), 10) || 6000;
    var index = 0;
    var timer = null;
    var visible = true;

    function show(next) {
      if (next === index) return;
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      if (bars.length) {
        bars[index].classList.remove('is-active');
        bars[index].setAttribute('aria-selected', 'false');
        // Rewind the bar before the next fill so the transition replays.
        var fill = bars[next].querySelector('i');
        if (fill) {
          fill.style.transition = 'none';
          fill.style.width = '0';
          void fill.offsetWidth;
          fill.style.transition = '';
          fill.style.width = '';
        }
        bars[next].classList.add('is-active');
        bars[next].setAttribute('aria-selected', 'true');
      }
      index = next;
    }

    function advance() { show((index + 1) % slides.length); }

    function start() {
      if (timer || REDUCED || !visible) return;
      timer = setInterval(advance, delay);
    }
    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    for (var i = 0; i < bars.length; i++) {
      (function (target) {
        bars[target].addEventListener('click', function () {
          stop();
          show(target);
          start();
        });
      })(i);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.05 }).observe(hero);
    } else {
      start();
    }

    start();
    hero.skHeroStop = stop;
  }

  function init(root) {
    var heroes = (root || document).querySelectorAll('.sk-hero2');
    for (var i = 0; i < heroes.length; i++) {
      var hero = heroes[i];
      if (hero.dataset.skHeroReady === '1') continue;
      hero.dataset.skHeroReady = '1';
      initVideo(hero);
      initSlides(hero);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: sections are re-rendered in place, so re-bind the new markup
  // and drop the timer belonging to the markup that was just thrown away.
  document.addEventListener('shopify:section:unload', function (e) {
    var hero = e.target.querySelector && e.target.querySelector('.sk-hero2');
    if (hero && hero.skHeroStop) hero.skHeroStop();
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
